import { useMemo, useState, useEffect, useRef } from 'react'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Dropdown, Text, Button } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { TransactionOrSplit } from '@/reducers/admin/allTransactions.slice'
import { useAnalyticsTrack } from '@/features/amplitude'
import { TransactionDetailsSheet } from '../transaction-details/TransactionDetailsSheet'
import { TransactionDeleteModal } from '@/features/transactions/TransactionDeleteModal'

export const TransactionDetailsMenu = ({
  transaction,
  review,
  toggleFileModal,
  isManualTransaction,
}: {
  transaction: TransactionOrSplit
  review?: boolean
  toggleFileModal: () => void
  isManualTransaction: boolean
}) => {
  const track = useAnalyticsTrack()
  const [open, setOpen] = useState(false)
  const [preventClose, setPreventClose] = useState(false)
  const [sheetOpen, setSheetOpen] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const content = useMemo(() => {
    return isManualTransaction
      ? {
          details: 'View/Edit Details',
          button: 'Delete Transaction',
        }
      : {
          details: 'View Details',
          button: 'Mark as Duplicate',
        }
  }, [isManualTransaction])

  const preventCloseRef = useRef(preventClose)

  useEffect(() => {
    preventCloseRef.current = preventClose
  }, [preventClose])

  const preventCloseAction = (value: boolean) => {
    setPreventClose(value)
  }

  const preventCloseGetter = () => {
    return preventCloseRef.current
  }

  const handleOpenTransactionDetails = (index: number) => {
    setActiveTabIndex(index)
    setSheetOpen(true)
    track('clicked transaction flyout button')
  }
  return (
    <>
      <Dropdown>
        <Dropdown.Trigger asChild>
          <Button
            variant="discreet"
            size="square"
            iconRight={solid('ellipsis')}
          />
        </Dropdown.Trigger>

        <Dropdown.Content align="end">
          <Dropdown.Item onClick={() => handleOpenTransactionDetails(0)}>
            <Text>{content.details}</Text>
          </Dropdown.Item>
          <Dropdown.Item onClick={toggleFileModal}>
            <Text>Upload Receipt</Text>
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleOpenTransactionDetails(1)}>
            <Text>Add Note</Text>
          </Dropdown.Item>

          {!transaction.reconciliationId && (
            <>
              <Dropdown.Separator />
              <Dropdown.Item onClick={() => setOpen(true)}>
                <Text
                  variant={TypographyStyles.BODY_SM}
                  color={
                    isManualTransaction ? TextColors.DANGER : TextColors.MUTED
                  }
                >
                  {content.button}
                </Text>
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Content>
      </Dropdown>

      <TransactionDeleteModal
        open={open}
        close={() => setOpen(false)}
        transactionId={transaction.id}
        isManualTransaction={isManualTransaction}
      />
      <TransactionDetailsSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        transaction={transaction}
        review={review}
        activeTabIndex={activeTabIndex}
        isManualTransaction={isManualTransaction}
        setPreventClose={preventCloseAction}
        preventClose={preventCloseGetter()}
      />
    </>
  )
}

export default TransactionDetailsMenu
